import {
  axiosService,
  fnoteService,
  lookntellApiService,
  onaviService,
  restApiService,
  shipService,
  weatherService,
} from './interceptors';
import { LocationItem } from 'constant';

const API_KEY = 'MPgnAFPD7y';

export interface AxiosResponseType {
  result: string;
  datas: any;
  data: any;
  it: any;
  vesselList: any;
  dataList: any;
  raiIdx: string;
  key?: string;
  isExpire?: boolean;
}

export const getLocation = async (roomId: string | undefined) =>
  (
    await axiosService.post<AxiosResponseType>(
      'getLocation',
      {},
      {
        params: {
          roomId,
        },
      }
    )
  ).data;

// 1.2.1
export const uploadData = async (data: FormData) =>
  (await axiosService.post<AxiosResponseType>(`organization/uploadData`, data, {})).data;

// 1.2.2
export const getUploadData = async () =>
  (await axiosService.post<AxiosResponseType>(`organization/getUploadData`, {}, {})).data;

// 1.2.3
export const registOrganizationUser = async (
  levelName: string,
  levelCIdx: number,
  name: string,
  phone: string,
  memo: string
) =>
  (
    await axiosService.post<AxiosResponseType>(
      'organization/registOrganizationUser',
      {},
      {
        params: {
          levelName,
          levelCIdx,
          name,
          phone,
          memo,
        },
      }
    )
  ).data;

// 1.2.4
export const updtOrganizationUser = async (
  userIdx: number | undefined,
  name: string,
  phone: string,
  resiNum: string,
  gender: string,
  country: string,
  addr: string,
  vesselYn: string,
  levelANm: string,
  levelBNm: string,
  levelCNm: string,
  levelIdx: number,
  special1: string,
  special2: string,
  resiDate: string
) =>
  (
    await axiosService.post<AxiosResponseType>(
      'organization/updtOrganizationUser',
      {},
      {
        params: {
          userIdx,
          name,
          phone,
          resiNum,
          gender,
          country,
          addr,
          vesselYn,
          levelANm,
          levelBNm,
          levelCNm,
          levelIdx,
          special1,
          special2,
          resiDate,
        },
      }
    )
  ).data;

// 1.2.5
export const delOrganizationUser = async (userIdx: number) =>
  (
    await axiosService.post<AxiosResponseType>(
      'organization/delOrganizationUser',
      {},
      {
        params: {
          userIdx,
        },
      }
    )
  ).data;

// 1.2.6
export const getSubOrganization = async (levelIdx: number, level: number) =>
  (
    await axiosService.post<AxiosResponseType>(
      'organization/getSubOrganization',
      {},
      {
        params: {
          levelIdx,
          level,
        },
      }
    )
  ).data;

// 1.2.7
export const getSubOrganizationUser = async (levelCIdx: number | null, searchType: string, searchKeyword: string) =>
  (
    await axiosService.post<AxiosResponseType>(
      'organization/getSubOrganizationUser',
      {},
      {
        params: {
          levelCIdx,
          searchType,
          searchKeyword,
        },
      }
    )
  ).data;

// 1.2.8
export const getUserList = async (levelCIdx: number | null, searchType: string, searchKeyword: string) =>
  (
    await axiosService.post<AxiosResponseType>(
      `user/getUserList`,
      {},
      {
        params: {
          levelCIdx,
          searchType,
          searchKeyword,
        },
      }
    )
  ).data;

// 1.2.9
export const delUser = async (userIdx: string) =>
  (
    await axiosService.post<AxiosResponseType>(
      `user/delUser`,
      {},
      {
        params: {
          userIdx,
        },
      }
    )
  ).data;

// 1.2.10
export const initPw = async (userIdx: string) =>
  (
    await axiosService.post<AxiosResponseType>(
      `user/initPw`,
      {},
      {
        params: {
          userIdx,
        },
      }
    )
  ).data;

// 1.2.11
export const updtUser = async (
  userIdx: string,
  id: string,
  nm: string,
  phone: string,
  role: string,
  group: string,
  oiIdx: number,
  status: string
) =>
  (
    await axiosService.post<AxiosResponseType>(
      `user/updtUser`,
      {},
      {
        params: {
          userIdx,
          id,
          nm,
          phone,
          role,
          group,
          oiIdx,
          status,
        },
      }
    )
  ).data;

// 1.2.12
export const getStatistic = async (type: string, startDay: string, endDay: string) =>
  (
    await axiosService.post<AxiosResponseType>(
      'statistic/getStatistic',
      {},
      {
        params: {
          type,
          startDay,
          endDay,
        },
      }
    )
  ).data;

// 1.2.13
export const regist = async (
  id: string,
  nm: string,
  pw: string,
  phone: string,
  role: string,
  group: string,
  oiIdx: number
) =>
  (
    await axiosService.post<AxiosResponseType>(
      `user/regist`,
      {},
      {
        params: {
          id,
          nm,
          pw,
          phone,
          role,
          group,
          oiIdx,
        },
      }
    )
  ).data;

// 1.2.14
export const login = async (id: string, pw: string) =>
  (
    await axiosService.post<AxiosResponseType>(
      'user/login',
      {},
      {
        params: {
          id,
          pw,
        },
      }
    )
  ).data;

// 1.2.15
export const chgPw = async (id: string, pw: string, chgPw: string) =>
  (
    await axiosService.post<AxiosResponseType>(
      'user/chgPw',
      {},
      {
        params: {
          id,
          pw,
          chgPw,
        },
      }
    )
  ).data;

// 1.2.16
export const getRoomList = async (groupIdx: number, userIdx: number, timeDay: string) =>
  (
    await axiosService.post<AxiosResponseType>(
      'getRooms',
      {},
      {
        params: {
          groupIdx,
          userIdx,
          timeDay,
        },
      }
    )
  ).data;

// 1.2.17
export const createRoom = async (groupIdx: number, userIdx: number) =>
  (
    await axiosService.post<AxiosResponseType>(
      'createRoom',
      {},
      {
        params: {
          groupIdx,
          userIdx,
        },
      }
    )
  ).data;

// 1.2.18
export const expireRoom = async (roomId: string | undefined, userIdx: number) =>
  (
    await axiosService.post<AxiosResponseType>(
      'expireRoom',
      {},
      {
        params: {
          roomId,
          userIdx,
        },
      }
    )
  ).data;

// 1.2.19
export const inviteUser = async (roomId: string, phone: string, name: string, role: string) =>
  (
    await axiosService.post<AxiosResponseType>(
      role === 'R' ? 'inviteUser_renew' : 'inviteUser',
      {},
      {
        params: {
          roomId,
          phone,
          name,
          role,
        },
      }
    )
  ).data;

// 1.2.20
export const getRoomUsers = async (roomId: string) =>
  (
    await axiosService.post<AxiosResponseType>(
      'getRoomUsers',
      {},
      {
        params: {
          roomId,
        },
      }
    )
  ).data;

// 1.2.21
export const updateRoom = async (
  roomId: string | undefined,
  lat: string | undefined,
  lng: string | undefined,
  accDate: string | undefined,
  accTime: string | undefined,
  accLoc: string | undefined,
  accDtl: string | undefined,
  prcRslt: string | undefined,
  dLoc: string | undefined,
  wCond: string | undefined,
  accType: string | undefined,
  dType: string | undefined,
  dRoute: string | undefined,
  mdn: string | undefined,
  alimType: string | undefined
) =>
  (
    await axiosService.post<AxiosResponseType>(
      'updateRoom',
      {},
      {
        params: {
          roomId,
          lat,
          lng,
          accDate,
          accTime,
          accLoc,
          accDtl,
          prcRslt,
          dLoc,
          wCond,
          accType,
          dType,
          dRoute,
          mdn,
          alimType,
        },
      }
    )
  ).data;

// 1.2.22
export const connectUser = async (
  roomId: string | undefined,
  phone: string | undefined,
  role: string | undefined,
  duration: number | undefined
) =>
  (
    await axiosService.post<AxiosResponseType>(
      'connectUser',
      {},
      {
        params: {
          roomId,
          phone,
          role,
          duration,
        },
      }
    )
  ).data;

// 1.2.23
export const disconnectUser = async (roomId: string | undefined, phone: string | undefined, role: string | undefined) =>
  (
    await axiosService.post<AxiosResponseType>(
      'disconnectUser',
      {},
      {
        params: {
          roomId,
          phone,
          role,
        },
      }
    )
  ).data;

// 1.2.24
export const getRoom = async (roomId: string) =>
  (
    await axiosService.post<AxiosResponseType>(
      'getRoom',
      {},
      {
        params: {
          roomId,
        },
      }
    )
  ).data;

// 1.2.25
export const addChat = async (
  roomId: string | undefined,
  chatId: number | string | undefined,
  chatNm: string | undefined,
  msg: string,
  chatType: number | null
) =>
  (
    await axiosService.post<AxiosResponseType>(
      'addChat',
      {},
      {
        params: {
          roomId,
          chatId,
          chatNm,
          msg,
          chatType,
        },
      }
    )
  ).data;

// 1.2.26
export const getChats = async (roomId: string | undefined) =>
  (
    await axiosService.post<AxiosResponseType>(
      `getChats`,
      {},
      {
        params: {
          roomId,
        },
      }
    )
  ).data;

// 1.2.27
export const addCapture = async (data: FormData) =>
  (await axiosService.post<AxiosResponseType>(`addCapture`, data, {})).data;

// 1.2.28
export const getMediaList = async (roomId: string | undefined) =>
  (
    await axiosService.post<AxiosResponseType>(
      'getMediaList',
      {},
      {
        params: {
          roomId,
        },
      }
    )
  ).data;

// 1.2.29

// 1.2.30
export const addLocation = async (locateLogs: LocationItem) =>
  (await axiosService.post<AxiosResponseType>(`addLocation`, locateLogs, {})).data;

// 1.2.31
export const organizationExDownload = async () =>
  await axiosService.get<AxiosResponseType>('organization/organizationExDownload', { responseType: 'blob' });

// 1.2.32
export const getRoomInfo = async (roomId: number) =>
  (
    await axiosService.post<AxiosResponseType>(
      'getRoomInfo',
      {},
      {
        params: {
          roomId,
        },
      }
    )
  ).data;

// 1.2.33
export const decryptPhone = async (encPhone: string) =>
  (
    await axiosService.post<AxiosResponseType>(
      'decryptPhone',
      {},
      {
        params: {
          encPhone,
        },
      }
    )
  ).data;

// 1.2.34
export const veseelViewHistory = async (name: string, mdn: string) =>
  (
    await axiosService.post<AxiosResponseType>(
      'veseelViewHistory',
      {},
      {
        params: {
          name,
          mdn,
        },
      }
    )
  ).data;

// 1.2.35
export const sendMsgToRoomUser = async (roomId: string, type: string | null, title: string, content: string) =>
  (
    await axiosService.post<AxiosResponseType>(
      'sendMsgToRoomUser',
      {},
      {
        params: {
          roomId,
          type,
          title,
          content,
        },
      }
    )
  ).data;

// 1.2.36
export const logout = async () => (await axiosService.post<AxiosResponseType>('user/logout', {}, {})).data;

// 1.2.37
export const getLocAlimList = async (timeDay: string) =>
  (
    await axiosService.post<AxiosResponseType>(
      'getLocAlimList',
      {},
      {
        params: {
          timeDay,
        },
      }
    )
  ).data;

// 1.2.38
export const updateLocAlim = async (
  raiIdx: string | undefined,
  roomId: string | undefined,
  vesselName: string | undefined,
  captainName: string | undefined,
  captainPhone: string,
  lastSentTime: string,
  lastLat: string,
  lastLng: string,
  status: string | null,
  alimType: string
) =>
  (
    await axiosService.post<AxiosResponseType>(
      'updateLocAlim',
      {},
      {
        params: {
          raiIdx,
          roomId,
          vesselName,
          captainName,
          captainPhone,
          lastSentTime,
          lastLat,
          lastLng,
          status,
          alimType,
        },
      }
    )
  ).data;

// 1.2.39
export const getViewerKey = async (roomId: string, userIdx: number) =>
  (
    await axiosService.post<AxiosResponseType>(
      'getViewerKey',
      {},
      {
        params: {
          roomId,
          userIdx,
        },
      }
    )
  ).data;

// 1.2.40
export const verifyViewerKey = async (roomId: string, viewerKey: string) =>
  (
    await axiosService.post<AxiosResponseType>(
      'verifyViewerKey',
      {},
      {
        params: {
          roomId,
          viewerKey,
        },
      }
    )
  ).data;

// Flashphoner rest-api
export const startRecording = async (data: FormData) =>
  (await restApiService.post<AxiosResponseType>(`stream/startRecording`, data, {})).data;

// Flashphoner rest-api
export const stopRecording = async (data: FormData) =>
  (await restApiService.post<AxiosResponseType>(`stream/stopRecording`, data, {})).data;

// From Koast Weather
export const getWeatherData = async (region: any, sdate: string, edate: string) =>
  (
    await weatherService.get<AxiosResponseType>('getWeatherbyLonLat', {
      params: {
        ServiceKey: API_KEY,
        lat: Number(region.lat),
        lon: Number(region.lng),
        sdate: sdate,
        edate: edate,
        '3h': '1',
      },
    })
  ).data;

// From Koast Tide
export const getTideData = async (region: any, sdate: string, edate: string) =>
  (
    await weatherService.get<AxiosResponseType>('getTidebyLonLat', {
      params: {
        ServiceKey: API_KEY,
        lat: Number(region.lat),
        lon: Number(region.lng),
        sdate: sdate,
        edate: edate,
        '3h': '1',
      },
    })
  ).data;

// From Marinetraffic
export const getVesselList = async (giIdx: string, searchKeyword: string) =>
  (
    await shipService.post<AxiosResponseType>(
      'searchVesselList',
      {},
      {
        params: {
          giIdx,
          searchKeyword,
        },
      }
    )
  ).data;

// From Marinetraffic
export const getDailyLocation = async (mdn: string, searchDate: string) =>
  (
    await shipService.post<AxiosResponseType>(
      'getDailyLocateByMdn',
      {},
      {
        params: {
          mdn,
          searchDate,
        },
      }
    )
  ).data;

// From FishingNote
export const getBoardingInfo = async (bbc: string, date: string) =>
  (
    await fnoteService.post<AxiosResponseType>(
      'remotehelp/rescueF/boatBoardingInfo.do',
      {},
      {
        params: {
          bbc,
          date,
        },
      }
    )
  ).data;

// From Marinetraffic
export const getTermLocateByMdn = async (
  mdn: string,
  searchDateTime: string,
  term: number,
  searchKeyword: string,
  radius: number
) =>
  (
    await shipService.post<AxiosResponseType>(
      'getTermLocateByMdn',
      {},
      {
        params: {
          mdn,
          searchDateTime,
          term,
          searchKeyword,
          radius,
        },
      }
    )
  ).data;

// From FishingNote
export const boatList = async (data: FormData) =>
  (await fnoteService.post<AxiosResponseType>('remotehelp/rescueF/boatList.do', data, {})).data;

// From ONAVI
export const onaviSearchVesselList = async (data: FormData) =>
  (await onaviService.post<AxiosResponseType>('sar/searchVesselList', data, {})).data;

// From ONAVI
export const onaviGetDailyLocateByMdn = async (data: FormData) =>
  (await onaviService.post<AxiosResponseType>('sar/getDailyLocateByMdn', data, {})).data;

// From ONAVI
export const onaviGetTermLocateByMdn = async (data: FormData) =>
  (await onaviService.post<AxiosResponseType>('sar/getTermLocateByMdn', data, {})).data;

// From LooknTell
export const LooknTellGetTermLocateByMdn = async (data: FormData) =>
  (await lookntellApiService.post<AxiosResponseType>('getTermLocateByMdn', data, {})).data;
